import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseBackendUrl } from '../utils/api-utils';
import { createBreakSuccess, getAllBreaks, getBreak, setBreakLoading } from "../redux/breakSlice";
import { getCurrentConditions } from "./buoyAPI";
import { updateBreak } from "../redux/breakSlice";

export const createNewBreak = createAsyncThunk('breaks/createNewBreak', async (arg, {dispatch}) => {
    dispatch(setBreakLoading())
    try {
        const response = await fetch(`${baseBackendUrl}/breaks/new`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + arg.token
            },
            body: JSON.stringify(arg.submitData)
        })
        
        if (response.ok) {
            const res = await response.json();
            console.log(res)
            dispatch(createBreakSuccess());
            arg.navigate("/app/breaks")
        }
    } catch (error) {
        console.log(error)
    }
})

export const getAll = createAsyncThunk('breaks/getAll', async (arg, {dispatch}) => {
    dispatch(setBreakLoading())
    try {
        const response = await fetch(`${baseBackendUrl}/breaks/all/${arg.userID}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + arg.token
            }
        });
        if (response.ok) {
            const res = await response.json();
            dispatch(getAllBreaks(res.breaks))
        }
    } catch (error) {
        console.log(error)
    }
})

export const getOne = createAsyncThunk('breaks/getOne', async (arg, {dispatch}) => {
    dispatch(setBreakLoading())
    try {
        const response = await fetch(`${baseBackendUrl}/breaks/${arg.id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + arg.token
            }
        });
        if (response.ok) {
            const res = await response.json();
            dispatch(getBreak(res.oneBreak));
            dispatch(getCurrentConditions({buoys: res.oneBreak.buoys, token: arg.token, breakID: arg.id}));
        }
    } catch (error) {
        console.log(error)
    }
})

export const breakUpdate = createAsyncThunk('breaks/updateOne', async (arg, {dispatch}) => {
    dispatch(setBreakLoading())
    try {
        const response = await fetch(`${baseBackendUrl}/breaks/${arg.id}`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + arg.token
            },
            body: JSON.stringify(arg.submitData)
        });
        if (response.ok) {
            const res = await response.json();
            dispatch(updateBreak(res));
        }
    } catch (error) {
        console.log(error)
    }
})

export const breakDelete = createAsyncThunk('breaks/delete', async (arg, {dispatch}) => {
    dispatch(setBreakLoading())
    try {
        const response = await fetch(`${baseBackendUrl}/breaks/${arg.id}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + arg.token
            },
        });
        if (response.ok) {
            const res = await response.json();
            dispatch(getAllBreaks(res));
            arg.navigate("/app/breaks")
        }
    } catch (error) {
        console.log(error)
    }
})